import YearAtAGlance from 'components/Content/BeautyInsider/BeautyInsiderModules/YearAtAGlance/YearAtAGlance';

export default YearAtAGlance;
